/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ComponentData, ComponentModel, ComponentFieldKey } from '../model/component.model';
import { ViewComponentKey } from '../key/view-component.key';

export class LoadIndicatorModel extends ComponentModel implements ComponentData {
  static readonly KEYS = ComponentModel.KEYS;

  constructor(data?: ComponentData, keys?: string[]) {
    super(data, keys || LoadIndicatorModel.KEYS);
  }

  protected setupValues(values: ComponentData, exclusive: boolean): ComponentData {
    if (exclusive && !(ComponentFieldKey.TYPE in values)) {
      values.type = ViewComponentKey.LOAD_INDICATOR;
    }
    return super.setupValues(values, exclusive) as ComponentData;
  }

}
